module.exports = __webpack_public_path__ + "img/banner-inauguracion.15b020eb.webp";